import script from "./KStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./KStatus.vue?vue&type=script&setup=true&lang=ts"

import "./KStatus.vue?vue&type=style&index=0&id=34693694&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34693694"]])

export default __exports__